import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from 'screens/components/basic/Button';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import Panel from 'screens/components/basic/Panel';
import LOOKUP from 'constants/lookup';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import { getDoctors, activateDoctor, inactivateDoctor } from 'actions/EntityActions';
import Grid from 'screens/components/basic/Grid';
import { doctorListCrumb } from 'utils/breadcrumbInfo';
import CardSimple from 'screens/components/basic/CardSimple';
import WithRouter from 'custom/withRouter';
//import SearchFields from './searchFields';

const pageName = "doctorList";
//Component for the listing of Doctors
class DoctorList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = { activePage: 1, itemsPerPage: 25 };
    }

    componentWillMount() {
        const s = this.state;
        this.props.init(s.activePage, s.itemsPerPage, this.props.branchId);
    }

    editDoctor(id) {
        this.props.callAddDoctorForm();
        this.props.navigate(`/doctor/edit/${id}`);
    }

    changePage(e) {
        this.setState({ activePage: e });
        this.props.init(e, this.state.itemsPerPage, this.props.branchId);
    }

    inactivateDoctor(id) {
        this.props.inactivateDoctor(id, this.state.itemsPerPage);
    }

    activateDoctor(id) {
        this.props.activateDoctor(id, this.state.itemsPerPage);
    }

    render() {
        const p = this.props;
        const s = this.state;
        const listDoctors = (p.doctors || []).map((item) => {
            return {
                ID: (<Link className="edit-link" to={`/doctor/edit/${item.id}`}>{item.id}</Link>),
                FirstName: (<Link to={`/doctor/edit/${item.id}`}>{item.firstName + " " + item.lastName}</Link>),
                LastName: (<Link to={`/doctor/edit/${item.id}`}>{item.lastName}</Link>),
                Position: item.position,
                Phone: item.phone,
                Status: (item.status !== "Active" ? <p className="statusIconRed m-0">{item.status}</p> :
                    <p className="statusIconGreen m-0">{item.status}</p>),
                Icons: (
                    <div className="row">
                        <div className="btn-group" role="group">
                            <Button
                                type="IconEditButton"
                                mini={true}
                                onTouchTap={() => this.editDoctor(item.id)} />
                            {/*
                            item.status === "Active" ?
                                <Button
                                    type="InactivateButton"
                                    label={LOOKUP.doctor.controls.inactivateButton}
                                    primary={true}
                                    onTouchTap={() => this.inactivateDoctor(item.id)} />
                                : <Button
                                    type="ActivateButton"
                                    label={LOOKUP.doctor.controls.activateButton}
                                    primary={true}
                                    onTouchTap={() => this.activateDoctor(item.id)} />
                        */}
                        </div>
                    </div>
                )
            };
        });

        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active">{LOOKUP.menu.user.items.doctor.text}</li>
                </ol>
                <h2> {LOOKUP.doctor.listTitle}</h2>
            </div>);

        const sideContent = (
            <Panel title="Toolbox">
                <div className="row text-center">
                    <Button type="AddButton"
                        className="toolbox-button"
                        label={LOOKUP.doctor.addNewButton}
                        onTouchTap={p.callAddDoctorForm} />
                </div>
                {/*<hr />
                <h4>Search</h4>*/}
            </Panel>
        );

        return (
            <Grid headerContent={doctorListCrumb}>
                <div className="page-top">
                    <div className="page-top-container">
                        <div className="page-title">
                            <h2>{LOOKUP.doctor.listTitle}</h2>
                        </div>
                        <div className="page-buttons">
                            <Button
                                type="AddButton"
                                mini={true}
                                className="bg-light-green"
                                label={LOOKUP.doctor.addNewButton}
                                onTouchTap={p.callAddDoctorForm} />
                        </div>
                    </div>
                    <CardSimple>
                        <div className="form-group">
                            <GenericTable
                                className="table_center"
                                multiSelectable={false}
                                enableSelectAll={false}
                                displaySelectAll={false}
                                adjustForCheckbox={false}
                                displayRowCheckbox={false}
                                selectable={true}
                                stripedRows={true}
                                columns={LOOKUP.doctor.tableColumns}
                                rows={listDoctors} />
                            <Pagination
                                length={p.doctorsLenght || 0}
                                itemsPerPage={s.itemsPerPage}
                                activePage={s.activePage}
                                onPageChange={() => this.changePage} />

                        </div>
                    </CardSimple>
                </div>
            </Grid>);
    }
}

function mapStateToProps(state) {
    return {
        doctors: state.entity.doctorList,
        doctorsLenght: state.entity.doctorListLength
    };
}

function mapDispatchToProps(dispatch) {
    return {
        init: (page, itemsPerPage, branchId) => dispatch(getDoctors(page, itemsPerPage, branchId)),
        activateDoctor: (id, itemsPerPage) => dispatch(activateDoctor(id, itemsPerPage)),
        inactivateDoctor: (id, itemsPerPage) => dispatch(inactivateDoctor(id, itemsPerPage))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(DoctorList));